import { render, staticRenderFns } from "./pageNotFound.vue?vue&type=template&id=97d5ba76&scoped=true&"
import script from "./pageNotFound.vue?vue&type=script&lang=js&"
export * from "./pageNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d5ba76",
  null
  
)

export default component.exports